module.exports = __webpack_public_path__ + "static/pas-logo-f6180e9383791f491c74ce9f4727cbd6.jpeg";